import { ComponentFactoryResolver, Injectable, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@app/common/store';
import { ComponentState } from '@app/models/component-state';
import { ComponentsOnRoutesState } from '@app/models/components-on-routes-state';

@Injectable({
  providedIn: 'root'
})
export class ComponentStatesOnRoutesService extends Store<ComponentsOnRoutesState> {

  hasInitialized = false;

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private router: Router) {
    super(null); // intialization is in initStates separately due to need for ViewContainerRef
  }

  initStates(viewContainerRef: ViewContainerRef) {
    if (!this.hasInitialized) {
      this.setState(new ComponentsOnRoutesState(this.router.config, this.componentFactoryResolver, viewContainerRef));
      this.hasInitialized = true;
    }
  }

  updateStates(updatedComponentState: ComponentState) {
    if (this.hasInitialized) {
      if (!updatedComponentState.Routes || updatedComponentState.Routes?.length === 0) {
        // if the state that needs to be updated doesnt have a route we try to find it. This could be when we're updating events from server side.
        this.state.RouteMap.forEach((componentState, route) => {
          const componentStatesForRouteWithSelector = componentState.filter(e => e.ComponentId === updatedComponentState.ComponentId);
          if (componentStatesForRouteWithSelector) {
            if (componentStatesForRouteWithSelector.length === 1) {
              if (!updatedComponentState.Routes) {
                updatedComponentState.Routes = [route];
              } else {
                updatedComponentState.Routes.push(route);
              }
            } else {
              componentStatesForRouteWithSelector.forEach(cState => {
                if (!updatedComponentState.Routes || updatedComponentState.Routes?.length === 0) {
                  if (updatedComponentState.Component) {
                    Object.keys(cState.Component.Configurations).forEach(key => {
                      if (updatedComponentState.Component.Configurations[key] && updatedComponentState.Component.Configurations[key] === cState.Component.Configurations[key]) {
                        if (!updatedComponentState.Routes) {
                          updatedComponentState.Routes = [route];
                        } else {
                          updatedComponentState.Routes.push(route);
                        }
                      }
                    });
                  } else {
                    if (updatedComponentState.Routes.indexOf(route) === -1) {
                      if (!updatedComponentState.Routes) {
                        updatedComponentState.Routes = [route];
                      } else {
                        updatedComponentState.Routes.push(route);
                      }
                    }
                  }
                }
              });
            }
          }
        });
      }

      if (updatedComponentState?.Routes?.length > 0) {
        updatedComponentState.Routes.forEach(route => {
          const componentStatesOnRoute = this.state.RouteMap.get(route);
          if (componentStatesOnRoute) {
            const existing = componentStatesOnRoute.find(componentEvent => componentEvent.ComponentId === updatedComponentState.ComponentId);
            if (existing) {
              const mappedComponenents = componentStatesOnRoute.map(currentComponentState => {
                if (currentComponentState.ComponentId === updatedComponentState.ComponentId) {
                  if (updatedComponentState.Data && currentComponentState.Data) {
                    currentComponentState.Data = updatedComponentState.Data.concat(currentComponentState.Data);
                  }
                  if (updatedComponentState.LastCheckedForNewContent) {
                    currentComponentState.LastCheckedForNewContent = updatedComponentState.LastCheckedForNewContent;
                  }
                  currentComponentState.ShowBadge = updatedComponentState.ShowBadge;
                  currentComponentState.Refresh = updatedComponentState.Refresh;
                }
                return currentComponentState;
              });
              this.state.RouteMap.set(route, mappedComponenents);
            } else {
              componentStatesOnRoute.push(updatedComponentState);
              this.state.RouteMap.set(route, componentStatesOnRoute);
            }
          } else {
            this.state.RouteMap.set(route, [updatedComponentState]);
          }
        });
      } else {
        if (this.state.MainMap.some(s => s.ComponentId === updatedComponentState.ComponentId)) {
          this.state.MainMap = this.state.MainMap.map(currentComponentState => {
            if (currentComponentState.ComponentId === updatedComponentState.ComponentId) {
              if (updatedComponentState.Data && currentComponentState.Data) {
                updatedComponentState.Data = updatedComponentState.Data.concat(currentComponentState.Data);
              }
              // Merge the updated state with current because we get some properties from different sources.
              updatedComponentState.Component = { ...currentComponentState.Component, ...updatedComponentState.Component };
              currentComponentState = updatedComponentState;
            }
            return currentComponentState;
          });
        } else {
          this.state.MainMap.push(updatedComponentState);
        }
      }

      this.setState(this.state);
    }
  }
}
